"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupersimplifierAccountsServiceClient = void 0;
const wealtho2_publicapi_client_1 = require("wealtho2-publicapi-client");
const ServiceClientHelper_1 = require("./ServiceClientHelper");
const enums_1 = require("../enums");
class SupersimplifierAccountsServiceClient {
    constructor(baseUrl, authService, logger = null, apiConfig) {
        const apiClient = new ServiceClientHelper_1.ServiceClientHelper(authService, logger, apiConfig);
        const superSimplifierAccountsClient = new wealtho2_publicapi_client_1.SuperSimplifierAccountsClient(baseUrl, apiClient.axiosInstance);
        apiClient.setAuthToken(superSimplifierAccountsClient, authService.getAccessToken());
        this.apiClient = apiClient;
        this.superSimplifierAccountsClient = superSimplifierAccountsClient;
    }
    getSuperSimplifierAccountsAsync(skip, take) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.superSimplifierAccountsClient, this.superSimplifierAccountsClient.getSuperSimpliferAccounts.bind(this.superSimplifierAccountsClient), enums_1.PublicApiName.SuperSimplifierAccounts, skip, take);
        });
    }
    getSuperSimpliferAccountAsync(accountNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.superSimplifierAccountsClient, this.superSimplifierAccountsClient.getSuperSimpliferAccount.bind(this.superSimplifierAccountsClient), enums_1.PublicApiName.SuperSimplifierAccount, accountNumber);
        });
    }
    getContributionsAsync(accountNumber, financialYearEndingYear) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.superSimplifierAccountsClient, this.superSimplifierAccountsClient.getContributions.bind(this.superSimplifierAccountsClient), enums_1.PublicApiName.SuperSimplifierContributions, accountNumber, financialYearEndingYear);
        });
    }
    getDocumentsAsync(accountNumber, skip, take) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.superSimplifierAccountsClient, this.superSimplifierAccountsClient.getDocuments.bind(this.superSimplifierAccountsClient), enums_1.PublicApiName.SuperSimplifierDocuments, accountNumber, skip, take);
        });
    }
}
exports.SupersimplifierAccountsServiceClient = SupersimplifierAccountsServiceClient;
